import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Row, Form, Input, Col, Select, Collapse, Modal, notification } from "antd";
import { useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const { confirm } = Modal;

const TenantUsers = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [TenantsUsers, setTenantsUsers] = useState([]);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    UserApi.tenantUsers(id, 0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenantsUsers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    UserApi.tenantUsers(id, pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setTenantsUsers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTenantsUsers = useCallback(() => {
    UserApi.tenantUsers(id, PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setTenantsUsers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getTenantsUsers();
    PageLoading();
  }, [PageLoading]);
  const formRef = useRef(null);


  const [filterUser, setFilterUser] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterUser = () => {
    setFilterUser([
      ...filterUser,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    let singleLineString = filterUser
      .map((obj) =>
        obj.answerType == "%"
          ? `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`
          : `${obj.title}${obj.answerType}${obj.name}`
      )
      .join("&");

    let filderData = window.btoa("componentCode=USER&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
    console.log(singleLineString);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        PageLoading();
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setTenantsUsers(response.payloadDto);
        setTotalElements(response.totalElements);
      })
      .catch((err) => { });
  };

  const handleChangeTitle = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].title = value;
    setFilterUser(newfilterUser);
  };
  const handleChangeAnswertype = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].answerType = value;
    setFilterUser(newfilterUser);
  };

  const handleChangename = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].name = value;
    setFilterUser(newfilterUser);
  };

  const handleRemovefilterUser = (FilterUserIndex) => {
    const newfilterUser = [...filterUser];
    newfilterUser.splice(FilterUserIndex, 1);
    setFilterUser(newfilterUser);
    if (FilterUserIndex == 0) {
      getTenantsUsers();
    }
  };

  const handleClear = () => {
    getTenantsUsers();
    PageLoading();
    setFilterUser([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleDeleteUser = (userId) => {
    UserApi.DeleteUsers(userId)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getTenantsUsers();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const showDeleteConfirm = (user) => {
    confirm({
      title: `Are you sure you want to delete user "${user?.email}"?`,
      content: "This action can not be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleDeleteUser(user?.id);

        console.log("deleting user:");
      },
      onCancel() {
        console.log("deletion cancelled");
      },
    });
  };

  const showResendEmailVerficationLinkConfirm = (user) => {
    confirm({
      title: `Are you sure you want to resend email verification link for user "${user?.email}"?`,
      content: "Reason you are sending this again because the user has not received for any reason or expired",
      okText: "Yes, Send",
      okType: "primary",
      cancelText: "Cancel",
      onOk() {
        UserApi.resendVerifyToken(user?.email)
          .then((response) => {
            notification.open({
              message: <span style={{ fontWeight: "bold" }}>Email verrification link resent Successfully!</span>,
              closeIcon: false,
              duration: 3,
              style: {
                backgroundColor: "#b3ffb3",
                color: "green",
              },
            });
            PageLoading();
            getTenantsUsers();
          })
          .catch((err) => {
            if (err.apiError.status) {
              notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: err.apiError.message,
                closeIcon: false,
                duration: 3,
                style: {
                  backgroundColor: "#fff2f0",
                  color: "red",
                },
              });
            }
          });
      },
      onCancel() {
        console.log("deletion cancelled");
      },
    });
  };

  const paginatedData = TenantsUsers;

  const renderTableRows = () => {
    return paginatedData.map((item) => (
      <tr key={item?.id} className="text-center">
        <td className="user-tableAvatar">
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              background: "#001529",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "8px",
              fontWeight: "bold",
              padding: "5px",
              color: "#fff",
              cursor: "pointer",
              marginRight: "10px",
              paddingRight: "5px",
              animation: "flash 1s infinite",
            }}
          >
            {item?.firstName?.charAt(0)}
            {item?.lastName?.charAt(0)}
          </div>
          <div className="">
            {item?.firstName} {item?.lastName}
          </div>
        </td>
        <td style={{ width: "22%" }}>{item?.email}</td>
        <td style={{ width: "22%" }} className="text-center">
          <span
            className={`badge badge-status ${item?.aptitudeTestStatus === "COMPLETED" && "badge-complete"
              }
            ${item?.aptitudeTestStatus === "PENDING" && "badge-pending"}`}
          >
            {item?.aptitudeTestStatus}
          </span>
        </td>
        <td style={{ width: "22%" }}>
          {new Date(item?.createdDate).toLocaleDateString()} |{" "}
          {new Date(item?.createdDate).toLocaleTimeString()}
        </td>
        <td className="d-flex justify-content-center align-items-center">
          <div className="dropdown">
            <Button
              type="default"
              className="dropdown-toggle"
              id={`actionMenu-${item.id}`}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Actions
            </Button>
            <ul
              className="dropdown-menu"
              aria-labelledby={`actionMenu-${item.id}`}
            >
              <li>
                <Button
                  type="button"
                  className="dropdown-item"
                  onClick={() => showResendEmailVerficationLinkConfirm(item)}
                >
                  Resend email verification link
                </Button>
              </li>
              { <li>
                <Button
                  type="button"
                  className="dropdown-item"
                  onClick={() => showDeleteConfirm(item)}
                >
                  Delete
                </Button>
              </li>}
            </ul>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterUser.map((input, filterUserIndex) => (
                    <div key={filterUserIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterUserIndex, value)
                              }
                              options={[
                                { value: "firstName", label: "Name" },
                                {
                                  value: "email",
                                  label: "Email",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name={`type${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(filterUserIndex, value)
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item
                            name={`name${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterUserIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterUserIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterUser}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterUser(filterUserIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>

              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Full Name</th>
                  <th className="text-center">Email</th>
                  <th className="text-center">Status</th>
                  <th>Registered Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
           {TenantsUsers.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={PaginatetotalPages}
            onPageChange={handlePageChange}
            maxVisiblePages={5}
            showPageInfo={true}
            totalItems={totalElements}
            pageSize={PaginateLimit}
          />
        )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default TenantUsers;
